import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — a swivel task chair: blue-grey seat pad at 0.48 and a
// short back on a matte-black column over a five-arm star base with casters.
const FRAME = "#2e2e30";
const PAD = "#8a9aa8";

export const officeChair = defineModel({
  id: "office-chair",
  batchId: "modern",
  name: "Office chair",
  tags: ["modern", "interior", "furniture", "office", "seating", "chair"],
  summary: "A swivel task chair on a five-arm star base with casters.",
  tiles: { w: 1, h: 1 },
  footprint: 0.7,
  parts(): Part[] {
    const parts: Part[] = [];
    // five-arm star base with caster spheres
    for (let i = 0; i < 5; i++) {
      const a = (i * 2 * Math.PI) / 5;
      const dx = Math.sin(a);
      const dz = Math.cos(a);
      parts.push({
        geometry: new THREE.BoxGeometry(0.06, 0.04, 0.3),
        color: FRAME,
        position: [dx * 0.16, 0.07, dz * 0.16],
        rotation: [0, a, 0],
      });
      parts.push({
        geometry: new THREE.SphereGeometry(0.04, 8, 6),
        color: FRAME,
        position: [dx * 0.29, 0.04, dz * 0.29],
      });
    }
    // central gas column
    parts.push({
      geometry: new THREE.CylinderGeometry(0.03, 0.035, 0.34, 8),
      color: FRAME,
      position: [0, 0.26, 0],
    });
    // seat pad (top at 0.48)
    parts.push({
      geometry: new THREE.BoxGeometry(0.46, 0.08, 0.46),
      color: PAD,
      position: [0, 0.44, 0],
    });
    // backrest support
    parts.push({
      geometry: new THREE.BoxGeometry(0.05, 0.26, 0.04),
      color: FRAME,
      position: [0, 0.56, -0.23],
    });
    // short back pad
    parts.push({
      geometry: new THREE.BoxGeometry(0.44, 0.34, 0.06),
      color: PAD,
      position: [0, 0.82, -0.22],
    });
    return parts;
  },
  animations: [],
});
